export default [
    {
        path: '/invite-page/index',
        name: 'invitePage',
        meta: {
            index: 1
        },
        component: () => import('@/views/invite-page/index.vue')
    }
]
